import { useCallback } from "react";
import { useDispatch } from "react-redux";

import extractName from "../helpers/extract-category-name";
import { actions } from "../Categories.redux";
const { fetchIfNeeded, lookup } = actions;

/**
 * Hook for getting function to retrieve category names
 * - Returning a function instead of the the actual names so
 *   that the `getBreadcrumbs` helper function can access data
 *   from the redux store
 * @returns {function}
 */
export default function useCategoryNames() {
  const dispatch = useDispatch();

  const getCategoryNames = useCallback(
    async (ids, asArray = false) => {
      try {
        if (!ids) {
          return "";
        }

        const status = await dispatch(fetchIfNeeded());

        if (!status || status === "error") {
          return "";
        }

        if (!Array.isArray(ids)) {
          ids = `${ids}`.replace(/\s+/g, "").split(",");
        }

        const names = await ids.reduce(async (formatted, id) => {
          try {
            formatted = await formatted;
            id = parseInt(id, 10);

            if (!isNaN(id)) {
              const { category, success } = await dispatch(lookup(id, true));

              if (success) {
                const name = extractName(category);

                if (asArray) {
                  formatted.push(category);
                } else {
                  formatted.push(name);
                }
              }
            }

            return formatted;
          } catch (err) {
            return await formatted;
          }
        }, []);

        return asArray
          ? names
          : names.sort((a, b) => a.localeCompare(b)).join(", ");
      } catch (err) {
        return asArray ? [] : "";
      }
    },
    [dispatch]
  );

  return getCategoryNames;
}
